import { FC } from 'react';
import { IonFab, IonFabButton } from '@ionic/react';
import { isPlatform } from '../utils/isPlatform';
import { Keyboard } from '@capacitor/keyboard';
import { MicrophoneIcon } from '../theme/Icons';
import { createUseStyles } from 'react-jss';
import { mediaMinWidth } from '../theme/utils';
import { SIDE_NAV_WIDTH } from '../navigation/NavConstants';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { RecordingState } from './RecordingState';
import { Recorder } from './Recorder';

export const FAB_WIDTH = 56;

const useStyles = createUseStyles({
    button: {
        marginBottom: 'var(--ion-safe-area-bottom, 0)',

        [mediaMinWidth.lg]: {
            bottom: 0,
            margin: (SIDE_NAV_WIDTH - FAB_WIDTH) / 2
        }
    },

    fabButton: {
        width: 46,
        height: 46,
        marginBottom: -5
    }
});

export const RecordButton: FC = () => {
    const classes = useStyles();

    const recordingState = useInstance(RecordingState);
    useSubscription(() => recordingState);

    // turn into anPaywallAwareButton (with sparkles?)
    // OR, use the logic in the button to determine if they can record another (5 for free, 6th costs)

    if (isPlatform('capacitor')) {
        Keyboard.addListener('keyboardWillShow', info => {
            document.body.classList.add('keyboard-open');
        });

        Keyboard.addListener('keyboardDidHide', () => {
            document.body.classList.remove('keyboard-open');
        });
    }

    return (
        <IonFab
            vertical="bottom"
            horizontal="center"
            data-id="record-button"
            className={`record-btn-fab ${classes.button}`}
        >
            <Recorder trackingFrom="Record Nav" includeSheet>
                <IonFabButton
                    id="record-btn"
                    className={classes.fabButton}
                    color={recordingState.isRecording() ? 'danger' : 'primary'}
                >
                    <MicrophoneIcon color="light" customSize={24} />
                </IonFabButton>
            </Recorder>
        </IonFab>
    );
};
